import { useSelector } from "react-redux";

const AppConfig = (configType) => {
  const { sessionID, userId, companyID } = useSelector(
    (state) => state.account
  );
  let configVal;
  switch (configType) {
    case "APIConfig":
      configVal = {
        headers: {
          "Content-Type": "application/json",
          "accept": "application/json",
          "X-SESSION-Key": sessionID,
          "user-id": userId,
          "company-id": companyID,
          "session-key": sessionID, // Include session-key in headers
          // Cookie: "session_id=" + sessionID,
          "Cache-Control": "no-cache",
        },
      };
      break;

    default:
      break;
  }
  return configVal;
};

export default AppConfig;
